import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ApiPlatformService} from "./api-platform.service";

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [ApiPlatformService]
})
export class ApiPlatformModule { }
